import PropTypes from "prop-types";

export default function ToggleInput({
  label,
  checked,
  onChange,
  type = "checkbox",
}) {
  const htmlId = label.replace(/\s+/g, "") + "Toggle";

  return (
    <div className="d-flex justify-content-end">
      <div className="form-check form-switch d-flex align-items-center">
        <label className="form-check-label text-muted me-3" htmlFor={htmlId}>
          {label}
        </label>
        <input
          className="form-check-input"
          style={{
            backgroundColor: checked ? "var(--brand-color-1)" : "#dee2e6",
            borderColor: checked ? "var(--brand-color-1)" : "#adb5bd",
            marginLeft: "0",
          }}
          type={type}
          id={htmlId}
          checked={checked}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

ToggleInput.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["checkbox"]),
};
